export default "__VITE_ASSET__CcmhwiQ5__"